import { Guid } from '@web/utils';

export class PublicBrandCosmeticBox {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
      slug: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }
}
